// extracted by mini-css-extract-plugin
export var bottomTriangle = "success-module--bottomTriangle--4181a";
export var dark = "success-module--dark--ae3c7";
export var icon = "success-module--icon--2ec02";
export var light = "success-module--light--a54e5";
export var successButtons = "success-module--successButtons--4b58e";
export var successContainer = "success-module--successContainer--5b6d2";
export var successContent = "success-module--successContent--25226";
export var successGrid = "success-module--successGrid--21447";
export var successHeadline = "success-module--successHeadline--22e30";
export var successMessage = "success-module--successMessage--8ed5c";